{
  "name": "bet-plus-web",
  "version": "4.0.9-14",
  "scripts": {
    "analyze": "npm run dev-analyze && npx source-map-explorer \"dist/bet-plus-web/browser/**/*.js\"",
    "ng": "ng",
    "compodoc": "npx compodoc -p tsconfig.doc.json --disableRoutesGraph",
    "start": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng serve  --host 0.0.0.0",
    "start-no-live-reload": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng serve --no-live-reload",
    "generate-build-info": "node scripts/generate-build-info.mjs",
    "build": "node scripts/generate-build-info.mjs && node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build && node scripts/generate-build-info.mjs --dist-only",
    "build-dev": "node scripts/generate-build-info.mjs && node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration development && node scripts/generate-build-info.mjs --dist-only",
    "dev": "node scripts/generate-build-info.mjs && node --max_old_space_size=30000 ./node_modules/@angular/cli/bin/ng build --configuration dev && node scripts/generate-build-info.mjs --dist-only",
    "qa": "node scripts/generate-build-info.mjs && node --max_old_space_size=30000 ./node_modules/@angular/cli/bin/ng build --configuration qa && node scripts/generate-build-info.mjs --dist-only",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:ci": "jest --ci",
    "test:coverage": "jest --coverage",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "lint:changed": "node scripts/lint-changed.mjs",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "dev-analyze": "node scripts/generate-build-info.mjs && node --max_old_space_size=30000 ./node_modules/@angular/cli/bin/ng build --configuration dev && node scripts/generate-build-info.mjs --dist-only",
    "esAnalizer": "node scripts/esbuild-analyze.mjs",
    "e2e": "ng e2e",
    "start:ssl": "ng serve --host 0.0.0.0 --ssl true --ssl-cert './localhost+2.pem' --ssl-key './localhost+2-key.pem'",
    "local": "ng serve --port 8080 --host 0.0.0.0 --disable-host-check true",
    "deploy-backoffice-dev": "sh scripts/deploy-backoffice-dev.sh",
    "deploy-backoffice-prd": "sh scripts/deploy-backoffice-prd.sh",
    "pre-commit": "lint-staged --no-stash true",
    "prepare": "husky install",
    "no-unused-file": "node check-unused-warning.js",
    "check:theming": "node scripts/check-theming.mjs",
    "check:any": "node scripts/check-any.mjs",
    "open:bo": "node scripts/open-bo.mjs"
  },
  "private": true,
  "pre-commit": [
    "lint",
    "circular-dependency-scan",
    "node ./scripts/check-unused-warning.js"
  ],
  "dependencies": {
    "@ag-grid-community/locale": "36.1.0",
    "@angular/animations": "^21.2.20",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.20",
    "@angular/compiler": "^21.2.20",
    "@angular/core": "^21.2.20",
    "@angular/forms": "^21.2.20",
    "@angular/material": "^21.2.14",
    "@angular/material-moment-adapter": "^21.2.14",
    "@angular/platform-browser": "^21.2.20",
    "@angular/platform-browser-dynamic": "^21.2.20",
    "@angular/router": "^21.2.20",
    "@angular/service-worker": "^21.2.20",
    "@babel/runtime": "^7.28.4",
    "@ctrl/tinycolor": "^4.0.3",
    "@danielmoncada/angular-datetime-picker": "21.0.0",
    "@iharbeck/ngx-virtual-scroller": "20.0.0",
    "@jsquash/avif": "^2.1.1",
    "@jsquash/png": "^3.1.1",
    "@jsquash/webp": "^1.5.0",
    "@lottiefiles/dotlottie-web": "^0.74.0",
    "@mendeldantas/ng-datatable": "0.1.8",
    "@ngbracket/ngx-layout": "21.0.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "16.0.1",
    "@rx-angular/cdk": "21.1.1",
    "@rx-angular/template": "21.2.1",
    "@tweenjs/tween.js": "^25.0.0",
    "@types/crypto-js": "^4.2.2",
    "@types/file-saver": "^2.0.5",
    "@types/jszip": "^3.4.0",
    "ag-charts-enterprise": "14.1.0",
    "ag-grid-angular": "36.1.0",
    "ag-grid-community": "36.1.0",
    "ag-grid-enterprise": "36.1.0",
    "angular-gridster2": "21.0.1",
    "angularx-qrcode": "21.0.5",
    "apexcharts": "^3.49.0",
    "cronstrue": "^2.50.0",
    "crypto-js": "^4.2.0",
    "dayjs": "^1.11.13",
    "file-saver": "^2.0.5",
    "fuse.js": "^7.1.0",
    "jszip": "^3.10.1",
    "libphonenumber-js": "^1.11.4",
    "lodash-es": "^4.17.21",
    "moment": "^2.29.1",
    "monaco-editor": "^0.52.2",
    "ng-apexcharts": "1.7.7",
    "ng-lazyload-image": "^9.1.3",
    "ng-recaptcha": "^11.0.0",
    "ngx-color-picker": "20.1.1",
    "ngx-drag-scroll": "21.0.0",
    "ngx-lottie": "^21.2.0",
    "ngx-mask": "21.1.0",
    "ngx-skeleton-loader": "13.0.0",
    "node-cpf": "^1.1.1",
    "nxt-json-view": "21.0.0",
    "randexp": "^0.5.3",
    "rxjs": "^7.5.0",
    "swiper": "12.1.3",
    "tslib": "^2.0.0",
    "vanilla-text-mask": "^5.1.1",
    "workbox-cli": "^7.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.21",
    "@angular-eslint/builder": "21.4.0",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/schematics": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/cli": "^21.2.21",
    "@angular/compiler-cli": "^21.2.20",
    "@angular/language-service": "^21.2.20",
    "@commitlint/cli": "^17.8.1",
    "@commitlint/config-conventional": "^17.8.1",
    "@compodoc/compodoc": "^1.1.26",
    "@eslint/js": "9.39.5",
    "@types/emscripten": "^1.41.5",
    "@types/jest": "^30.0.0",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^22.10.2",
    "@typescript-eslint/eslint-plugin": "8.67.0",
    "@typescript-eslint/parser": "8.67.0",
    "autoprefixer": "^10.4.23",
    "commitlint-plugin-function-rules": "^2.0.2",
    "esbuild": "^0.27.3",
    "eslint": "9.39.5",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jsdoc": "^50.6.3",
    "eslint-plugin-prettier": "^5.2.3",
    "eslint-plugin-unused-imports": "^4.1.4",
    "husky": "^8.0.3",
    "jest": "^30.3.0",
    "jest-environment-jsdom": "^30.3.0",
    "jest-preset-angular": "^17.0.0",
    "lint-staged": "^13.3.0",
    "ngx-clipboard": "^15.1.0",
    "postcss": "^8.5.6",
    "prettier": "^3.5.2",
    "tailwindcss": "^3.4.19",
    "ts-node": "~7.0.0",
    "typescript": "~5.9.3",
    "validate-branch-name": "^1.3.0",
    "workbox-build": "^7.3.0"
  },
  "_comment_overrides": "Conjunto forçado (Batch 8). Só entra aqui pacote cujo peer o Angular 21 NÃO satisfaz — verificado com `npm view <pkg> peerDependencies`, não presumido. `$@angular/core` manda o npm usar a versão da raiz. Os outros candidatos do plano NÃO precisam de override: ng-lazyload-image peers >=11.0.0 e @mendeldantas/ng-datatable peers >=2.0.0, ambos satisfeitos; @iharbeck/ngx-virtual-scroller saiu do conjunto (15.2.0 -> 20.0.0); angular2-chartjs não é dependência deste projeto.",
  "_comment_ng_recaptcha": "O pacote está abandonado (último publish 2023-11-25) e o override é sobre a versão FIXADA aqui, ^11.0.0, cujo peer é @angular/core ^15.0.0. A mesma versão roda em produção no bet-plus-web sobre Angular 21 — essa é a evidência que sustenta o forçamento. ATENÇÃO ao ler o `npm view ng-recaptcha peerDependencies`: ele responde sobre a última publicada, 13.2.1, cujo peer é ^17.0.0. Ou seja, existe um 13.2.1 que encurtaria o vão de 6 para 4 majors — ele ainda precisaria do mesmo override, então não é saída, é redução de risco. Subir 11 -> 13 é ticket próprio: muda o pacote na tela de login, e o aceite depende de login manual no browser (login.component.spec está no conjunto de falhas herdadas, ver docs/angular-21-upgrade.md).",
  "overrides": {
    "ng-recaptcha": {
      "@angular/core": "$@angular/core"
    }
  },
  "lint-staged": {
    "src/**/*.{json,md,css,scss}": [
      "prettier --write"
    ],
    "src/**/*.html": [
      "prettier --write",
      "node scripts/eslint-gated.mjs --fix"
    ],
    "*.ts": [
      "prettier --write",
      "node scripts/eslint-gated.mjs --fix"
    ]
  },
  "validate-branch-name": {
    "pattern": "^(master|develop){1}$|^(feature|feat|fix|bug|docs|improvement|improve)/[0-9]{1,}[-][a-zA-Z0-9-]+$",
    "errorMsg": "Branch name invalid. Valid branch Ex: fix/043-FeatureDescription"
  }
}
